import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/lib/constants";

export default function AddScraperDialog({ open, onOpenChange, onChooseCatalog, onChooseCustom }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add a Connection</DialogTitle>
          <DialogDescription>
            Choose how you'd like to add a new connection to your account.
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-2">
          <Button
            className="w-full h-auto py-4 text-white flex flex-col items-start gap-1"
            style={{ backgroundColor: BRAND.bg }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = BRAND.hover)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = BRAND.bg)}
            onClick={() => {
              onOpenChange(false);
              onChooseCatalog();
            }}
          >
            <span className="font-semibold text-sm">Use Catalog Portal</span>
            <span className="text-xs opacity-80 font-normal text-left">
              Subscribe to an existing connection from our catalog
            </span>
          </Button>

          <Button
            variant="outline"
            className="w-full h-auto py-4 flex flex-col items-start gap-1"
            onClick={() => {
              onOpenChange(false);
              onChooseCustom();
            }}
          >
            <span className="font-semibold text-sm">Request Special Portal</span>
            <span className="text-xs text-gray-500 font-normal text-left">
              Submit a custom portal URL for us to build a connection
            </span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
